export default __webpack_public_path__ + "static/media/photo-1573140247632-f8fd74997d5c.79b738bd.jpeg";